/* eslint-disable react/jsx-props-no-spreading */
import { bool, func, number, string, object } from 'prop-types';
import React from 'react';
import Header from './Header';
import Panel from './Panel';

const AccordionSection = React.memo(
    ({
        index,
        isExpanded,
        onClick,
        toggleControlLeft,
        iconSize,
        panelLeftIndent,
        header,
        panel,
        parentSection,
        isGalleryFilter,
    }) => {
        return (
            <>
                <Header
                    isExpanded={isExpanded}
                    onClick={onClick}
                    header={header}
                    toggleControlLeft={toggleControlLeft}
                    iconSize={iconSize}
                    index={index}
                    parentSection={parentSection}
                />
                <Panel
                    panel={panel}
                    toggleControlLeft={toggleControlLeft}
                    panelLeftIndent={panelLeftIndent}
                    isExpanded={isExpanded}
                    index={index}
                    parentSection={parentSection}
                    isGalleryFilter={isGalleryFilter}
                />
            </>
        );
    },
    (prevProps, nextProps) => {
        return (
            prevProps.header === nextProps.header &&
            prevProps.isExpanded === nextProps.isExpanded &&
            prevProps.panel === nextProps.panel
        );
    }
);

AccordionSection.propTypes = {
    index: number.isRequired,
    isExpanded: bool.isRequired,
    onClick: func.isRequired,
    iconSize: string.isRequired,
    toggleControlLeft: bool.isRequired,
    panelLeftIndent: bool.isRequired,
    header: string.isRequired,
    panel: object.isRequired,
    parentSection: string.isRequired,
};

export default AccordionSection;
